import { useIsLoggedOn } from "./useIsLoggedOn";
import { useNullableDealerAccountInfo } from "./useNullableDealerAccountInfo";

export const useDealerChassisSetting = (): boolean => {
  const dealer = useNullableDealerAccountInfo();
  const isLoggedOn = useIsLoggedOn();

  switch (dealer?.dealerEnableAdvancedSearchVehicleChassis) {
    case "SHOW":
      return true;
    case "AUTH":
      return isLoggedOn;
    default:
      return false;
  }
};
